<template>
    <div>
      <modal-form v-model="show" :size="size" :key="uniqueKey" :show-submit="false" text-close="Fechar">
        <template v-slot:title v-if="isAvalista">
          <v-icon class="mr-2"> fas fa-edit </v-icon>
          Documentos - {{ model.Nome }}
        </template>
        <template v-slot:title v-else-if="isVeiculo">
          <v-icon class="mr-2"> fas fa-edit </v-icon>
          Documentos - {{ model.Marca }} - {{ model.Modelo }}
        </template>
        <template v-slot:title v-else>
          <v-icon class="mr-2"> fas fa-edit </v-icon>
          {{ tipo.title }}
        </template>
        <template v-slot:body v-if="hasDocumentoGrid">
          <DocumentoGrid
            :tipo="tipo"
            hasEdit
            alertText="Deseja incluir documentos?"
            :documentoCliente="documentoCliente"
            :codigoProposta="codigoProposta"
            :codigoPessoa="codigoPessoa"
          />
        </template>
        <template v-slot:body v-else>
          <core-grid
            ref="grid"
            :onRead="onRead"
            :schema="schema"
            :auto-bind="false"
            mobile-breakpoint="0"
            modal
            flat
            :hide-all-options="!hasDocumentoEdit && !isAvalista && !showOptions"
            :grid-role="tipo.gridRoleModal"
            :delete-option="!isAvalista && showOptions"
            :add-option="addOption"
            :search-disabled="searchDisabled">
            <template v-slot:item.TipoDocumento="{ item }">
              <v-icon v-if="isAvalista" class="mr-2" size="dense" @click="downloadDocumento(item)">
                ph-file-arrow-down
              </v-icon>
              <v-icon v-else class="mr-2" size="dense" @click="downloadDocumento(item)">
                fas fa-file-download
              </v-icon>
              <a @click="downloadDocumento(item)">
                {{
                  $aux.TipoDocumento.find((p) => p.value === item.TipoDocumento).text || item.TipoDocumentoDescricao
                }}
              </a>
            </template>
          </core-grid>
          <DocumentoEdit
            v-if="isAvalista"
            ref="editar"
            isAvalista
            hasEdit
            :tipo="$aux.TipoDocumentoEntidade.Proposta"
            :codigoProposta="codigoProposta"
            :documentoCliente="model.DocumentoFederal"
            :papelAvalista="model.Papel"
            :hasConjuge="model.PropostaAvalistaPF && !!model.PropostaAvalistaPF.CPFConjuge"
            :avalistaConjuge="model.PropostaAvalistaPF"
            :validadeRequired="validadeRequired"
            :nomeAvalista="model.Nome"
            @close="response"
          />
        </template>
      </modal-form>
      <DocumentoEdit
        v-if="hasDocumentoEdit"
        ref="editar"
        :tipo="tipo"
        :isVeiculo="isVeiculo"
        :codigoVeiculo="model.CodigoIdentificador"
        :isVeiculoZeroKM="model.ZeroKM"
        hasEdit
        :codigoProposta="codigoProposta"
        :codigoPessoa="codigoPessoa"
        :documentoCliente="model.DocumentoFederal || model.Cliente?.DocumentoFederal"
        :validadeRequired="validadeRequired"
        @close="response"
      />
    </div>
  </template>

<script>
export default {
  props: {
    hasDocumentoGrid: { type: Boolean, default: false },
    hasDocumentoEdit: { type: Boolean, default: false },
    showOptions: { type: Boolean, default: false },
    addOption: { type: Boolean, default: true },
    searchDisabled: { type: Boolean, default: false },
    size: { type: String, default: 'md' },
    tipo: { type: Object, required: true }, // 'pessoa' ou 'proposta'
    codigoPessoa: { type: String, default: null },
    codigoProposta: { type: String, default: null },
    documentoCliente: { type: String, default: null },
    validadeRequired: { type: Boolean, default: false },
    isAvalista: { type: Boolean, default: false },
    isVeiculo: { type: Boolean, default: false }
  },
  data () {
    return {
      show: false,
      model: {},
      schema: [
        { value: 'TipoDocumento', text: 'Tipo Documento' },
        { value: 'NomeArquivo', text: 'Nome Arquivo' },
        { value: 'DtValidade', text: 'Válido até', format: 'date' },
      ],
    };
  },
  computed: {
    uniqueKey () {
      if (this.isAvalista) {
        return this.model.Codigo
      } else if (this.tipo === this.$aux.TipoDocumentoEntidade.Pessoa) {
        return this.codigoPessoa
      } return this.codigoProposta
    },
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true;
      if (sender) {
        th.model = sender;
        if (th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa) {
          th.$api.UI.Timeout.GridRefresh(th);
        } else {
          th.$api.UI.Timeout.Default(() => {
            if (th.$refs && th.$refs.grid) {
              th.$refs.grid.refresh();
            } else {
              return 10;
            }
          });
        }
      }
    },
    onRead (options, search) {
      const th = this
      const dto =
          th.tipo === th.$aux.TipoDocumentoEntidade.Pessoa
            ? {
              parameters: [
                { name: 'CodigoPessoa', value: th.codigoPessoa },
                { name: 'CodigoProposta', value: th.codigoProposta },
              ],
            }
            : {
              parameters: [{ name: 'CodigoProposta', value: th.codigoProposta }],
            };

      th.$api.Multiplo.Post(th.tipo.apiEndpoint, dto).then((response) => {
        if (th.$api.UI.PostLoadData(response)) {
          if (th.isVeiculo) {
            const listaVeiculos = response.Data.filter(doc => !doc.NomeArquivo?.includes(th.model.CodigoIdentificador))
            th.isVeiculo ? options.success(response.Data.filter(({ NomeArquivo }) => NomeArquivo.includes(th.model.CodigoIdentificador))) : options.success(listaVeiculos)
          } else {
            const listaFiltrada = response.Data.filter(doc => !doc.NomeArquivo?.includes('Representante Legal') && !doc.NomeArquivo?.includes('Avalista'))
            th.isAvalista ? options.success(response.Data.filter(({ NomeArquivo }) => NomeArquivo.includes(th.model.Nome))) : options.success(listaFiltrada)
          }
        }
      });
    },
    downloadDocumento (current) {
      window.open(
          `${process.env.VUE_APP_ROOT_WEBURL}download.aspx?type=${this.tipo.tipoDownloadDoc}&code=${current.Codigo}`
      );
    },
    refresh () {
      this.$refs.grid.refresh();
    },
    response (data) {
      if (data) this.refresh();
    },
    excluir (current) {
      const th = this
      if (current) {
        const dto = {
          guidID: current.Codigo
        }
        th.$api.Multiplo.Post(th.tipo.apiRemoverDocumento, dto).then(function (data) {
          if (th.$api.UI.PostAction(data)) {
            th.refresh()
          }
        })
      }
    }
  },
};
</script>
